import { memo } from "react";

import { Box, Chip } from "@mui/material";

import { useBszPlannerContext } from "../../../../2_BSZPlannerApp/context/bszPlannerContext";
import BszSectionCard from "../BszSectionCard";

function PlannerClassSelectorSection() {
  const { myClasses, selectedClass, setSelectedClass } = useBszPlannerContext();

  const classes = [...myClasses].sort((a, b) =>
    a.name.localeCompare(b.name, "de"),
  );
  return (
    <BszSectionCard title="Klassen" defaultExpanded>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Chip
          label="Meine Projekte"
          clickable
          color={selectedClass === null ? "primary" : "default"}
          onClick={() => setSelectedClass(null)}
        />

        {classes.map((cls) => (
          <Chip
            key={cls.id}
            label={cls.name}
            clickable
            color={selectedClass?.id === cls.id ? "primary" : "default"}
            onClick={() => setSelectedClass(cls)}
          />
        ))}
      </Box>
    </BszSectionCard>
  );
}

export default memo(PlannerClassSelectorSection);
